(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adg-gift-purchase"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-adg-gift-form]').forEach(function(form){
  if(form.dataset.ready)return;
  form.dataset.ready='true';
  var busy=false;
  form.addEventListener('submit',async function(event){
    event.preventDefault();event.stopImmediatePropagation();
    if(busy||!form.reportValidity())return;
    busy=true;
    var button=form.querySelector('button[type="submit"]'),status=form.querySelector('[data-gift-status]');
    button.disabled=true;button.textContent=button.dataset.busy;status.textContent='';
    try{
      var payload=new FormData(form);
      var response=await fetch(form.action+'.js',{method:'POST',body:payload,headers:{Accept:'application/json'}});
      var result=await response.json();
      if(!response.ok)throw new Error('add_failed');
      status.textContent=status.dataset.success;
      form.querySelector('[data-gift-cart]').hidden=false;
    }catch(error){status.textContent=status.dataset.error;}
    finally{busy=false;button.disabled=false;button.textContent=button.dataset.idle;}
  },true);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(function(){
  function init(){
    var reminder=document.getElementById('adg-last-minute');
    if(!reminder||reminder.dataset.ready) return;
    reminder.dataset.ready='true';
    var storageKey='adg-last-minute-dismissed';
    function isDismissed(){
      try { if(sessionStorage.getItem(storageKey)==='1') return true; } catch(error){}
      return document.cookie.split(';').some(function(part){return part.trim()==='adg_reminder_dismissed=1';});
    }
    function syncReminder(){reminder.hidden=isDismissed();}
    syncReminder();
    window.addEventListener('pageshow',syncReminder);
    reminder.querySelector('.adg-last-minute__dismiss').addEventListener('click',function(event){event.preventDefault();event.stopPropagation();reminder.hidden=true;try{sessionStorage.setItem(storageKey,'1');}catch(error){}document.cookie='adg_reminder_dismissed=1; Path=/; SameSite=Lax; Secure';});
    function positionReminder(){var header=document.querySelector('header.header');var bottom=header?header.getBoundingClientRect().bottom:0;reminder.style.setProperty('--adg-reminder-top',Math.max(16,Math.min(bottom+16,window.innerHeight-220))+'px');}
    positionReminder();
    window.addEventListener('resize',positionReminder,{passive:true});
    window.addEventListener('scroll',positionReminder,{passive:true});
    if(window.ResizeObserver){var header=document.querySelector('header.header');if(header)new ResizeObserver(positionReminder).observe(header);}
    document.addEventListener('keydown',function(event){if(event.key==='Escape'&&reminder.open&&!document.querySelector('dialog[open],[aria-modal="true"]:not([aria-hidden="true"])')){reminder.open=false;reminder.querySelector('summary').focus();}});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();

  } catch(e) { console.error(e); }
})();
})();
